import { params } from "@/params";
import { useAuthorizedMutation, useAuthorizedQuery } from "..";

export const useTicket = (ticketId: string, enabled: boolean) => {
  return useAuthorizedQuery({
    url: `${params.API_URL}/platform/tickets/${ticketId}`,
    queryKey: `getTicket-${ticketId}`,
    enabled,
  });
};

export const useInsights = (ticketId: string, enabled: boolean) => {
  return useAuthorizedQuery({
    url: `${params.API_URL}/platform/extension/tickets/${ticketId}/insights`,
    queryKey: `getTicketsInsightsAndSuggResposne-${ticketId}`,
    enabled,
  });
};

export const useGetAllConfigurationBlocks = (enabled: boolean) => {
  return useAuthorizedQuery({
    url: `${params.API_URL}/platform/extension-admin/configuration`,
    queryKey: `getAllConfigurationBlocks`,
    enabled,
  });
};

export const useUpdateConfigurationBlockOrder = () => {
  return useAuthorizedMutation({
    url: `${params.API_URL}/platform/copilot/configuration-blocks/order`,
    method: "PUT",
  });
};

export const useAddConfigurationBlock = () => {
  return useAuthorizedMutation({
    url: `${params.API_URL}/platform/copilot/configuration-blocks`,
    method: "POST",
  });
};

export const useDeleteConfigurationBlock = () => {
  return useAuthorizedMutation({
    url: `${params.API_URL}/platform/copilot/configuration-blocks`,
    method: "DELETE",
  });
};
type TicketCalculations = {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  tenantId: string;
  ticketId: string;
  avgQaScores: number | null;
  backAndForth: number | null;
  publicMessagesCount: number | null;
  internalMessagesCount: number | null;
  timeToResolution: number | null;
  timeToFirstResponse: number | null;
  isQuackInvolved: boolean;
};

type Ticket = {
  id: string;
  subject: string;
  ticketCalculations: TicketCalculations | null;
  topic: { topic: string };
  insights: {
    sentiment: number;
  }[];
};

export type CopilotFeedback = {
  id: string;
  tenantId: string;
  createdAt: Date;
  updatedAt: Date;
  ticketId: string;
  isPositive: boolean;
  comment: string | null;
  ticket: Ticket;
};

export type CopilotAuditLog = {
  id: string;
  tenantId: string;
  createdAt: Date;
  updatedAt: Date;
  ticketId: string;
  blockId: string;
  ticket: Ticket;
};

type CopilotData = {
  copilotFeedbacks: CopilotFeedback[];
  copilotAuditLogs: CopilotAuditLog[];
};

export const useGetCopilotData = (tenantId: string, enabled: boolean) => {
  return useAuthorizedQuery<CopilotData>({
    url: `${params.API_URL}/platform/extension-admin/copilot-data/${tenantId}`,
    queryKey: `getCopilotData-${tenantId}`,
    enabled,
  });
};
